import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { ineligibleStatusSchema } from './types'

export const ineligibleStatus = () => {
  return {
    schema: ineligibleStatusSchema,
    stepContent: [
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privateHealth:steps.ineligible.text',
        },
      },
    ],
    nextStep: 'login',
    subFlow: SubFlow.PrivateHealth,
  } as const satisfies AnyStepConfiguration
}
